module.exports = __webpack_public_path__ + "static/img/1.84e4495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/1.png
// module id = EG63
// module chunks = 0